import React from "react";
import { Container } from "react-bootstrap";
import ActiveSubscribeForm from "components/active-subscribe-form";
import Image from "components/image";
import {
  subscribe, subscribeInput, newsletterContainer, imageContainer,
  smallerImage, largerSubscriberInput, newsletterSmallContainer
} from "./style.mod.scss";
import NewsletterNewLayout from "./new-layout";

const Newsletter = ({ data }) => {

  const { newLayout, smallerImg } = data;
  const bgColor = data.bgColor && data.bgColor.hex;


  return newLayout ? <NewsletterNewLayout data={data} /> : (
    <div className={subscribe} style={{ backgroundColor: bgColor }}>
      <Container >
        <div className={(data?.image && smallerImg) ? newsletterSmallContainer : newsletterContainer }>
          {data?.image &&
            <div className={`${smallerImg && smallerImage} ${imageContainer}`}>
              <Image image={data?.image} alt={data?.image?.alt} />
            </div>}
          <div className={`${smallerImg && largerSubscriberInput} ${subscribeInput}`}>
            <ActiveSubscribeForm data={data} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Newsletter;
